import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import MainMenuPage from './pages/MainMenu';
import GamePage from './pages/Game';
import Tutorial from '../src/components/Tutorial';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import MainPage from './pages/MainPage';
// window.onpopstate = function () {
// 	debugger
// 	//context._refreshPage();
//   };
// window.addEventListener("locationchange", function () {
// 	debugger
// 	//context._refreshPage();
// });

const App: React.FC = () => (
	<IonApp>
		<IonReactRouter>
			<IonRouterOutlet>
				{/*<Route path={process.env.PUBLIC_URL + "/main-menu"} component={MainMenuPage} exact={true} />*/}

				{/*<Route path={process.env.PUBLIC_URL + "/game/PracticeScenarioA"} exact={true} render={() => <GamePage scenarioId="PracticeScenarioA" />} />
				<Route path={process.env.PUBLIC_URL + "/game/PracticeScenarioB"} exact={true} render={() => <GamePage scenarioId="PracticeScenarioB" />} />
				<Route path={process.env.PUBLIC_URL + "/game/PracticeScenarioC"} exact={true} render={() => <GamePage scenarioId="PracticeScenarioC" />} />
				<Route path={process.env.PUBLIC_URL + "/game/PracticeScenarioD"} exact={true} render={() => <GamePage scenarioId="PracticeScenarioD" />} />

				<Route path={process.env.PUBLIC_URL + "/game/TestScenarioA"} render={() => <GamePage scenarioId="TestScenarioA" />} />
				<Route path={process.env.PUBLIC_URL + "/game/TestScenarioB"} render={() => <GamePage scenarioId="TestScenarioB" />} />
				<Route path={process.env.PUBLIC_URL + "/game/TestScenarioC"} render={() => <GamePage scenarioId="TestScenarioC" />} />
				<Route path={process.env.PUBLIC_URL + "/game/TestScenarioD"} render={() => <GamePage scenarioId="TestScenarioD" />} />

				<Route path={process.env.PUBLIC_URL + "/tutorial"} component={Tutorial} />
				<Route path={process.env.PUBLIC_URL} component={MainMenuPage} exact={true} />

				only this line
				<Route path={process.env.PUBLIC_URL} component={MainPage} exact={true} />

				<Route exact path={process.env.PUBLIC_URL} render={() => <Redirect to={process.env.PUBLIC_URL + "/main-menu"} />} /> */}
				<MainPage></MainPage>
			</IonRouterOutlet>
		</IonReactRouter>
	</IonApp>
);

export default App;
